export default "__VITE_ASSET__DVqJsc5N__"